import Chart from './chart/Chart';
import ChartLegend from './chartLegend/ChartLegend';
import React from 'react';

import './chartGroup.scss';

export interface IGroupData {
    labels: Array<string>;
    data: Array<number>;
    colors: Array<string>;
    product: string;
}

const ChartGroup: React.FC<{ data: IGroupData }> = ({ data }) => {
    const chartData = {
        labels: data.labels,
        datasets: [
            {
                data: data.data,
                backgroundColor: data.colors,
                cutout: '90%',
            },
        ],
    };
    const legendData = {
        labels: data.labels,
        colors: data.colors,
        data: data.data,
    };
    return (
        <div className='status-summary-body_chart-group'>
            <Chart data={chartData} product={data.product}></Chart>
            <ChartLegend data={legendData}></ChartLegend>
        </div>
    );
};

export default ChartGroup;
